
//----------------------------------------------------------------------------
// WARNING!  Any changes you make to this file may be lost!
//
// This file is generated by the scripts/badger-ui-icons.js script in the
// badger-ui distribution.
//
// If you want to add new icons or change the existing icons then you should
// update icons/config.yaml and then run 'yarn icons' from the command line.
// That will rebuild this file.
//----------------------------------------------------------------------------

// define lists of icon names, e.g. for generating style guide
const iconSets = {
  regular: [
    'check-circle',
    'circle',
    'dot-circle',
    'face-frown',
    'square'
  ],
  solid: [
    'angle-down',
    'angle-left',
    'angle-right',
    'angle-up',
    'arrow-down',
    'arrow-left',
    'arrow-right',
    'arrow-up',
    'asterisk',
    'at',
    'ban',
    'bars',
    'caret-down',
    'caret-left',
    'caret-right',
    'caret-square-left',
    'caret-square-right',
    'caret-up',
    'cat',
    'check',
    'check-square',
    'circle',
    'circle-check',
    'circle-exclamation',
    'circle-question',
    'clipboard-list',
    'cog',
    'cogs',
    'exclamation-triangle',
    'filter',
    'info-circle',
    'key',
    'plus',
    'radiation',
    'rotate-left',
    'search',
    'sort',
    'sort-down',
    'sort-up',
    'times',
    'times-circle',
    'toggle-off',
    'toggle-on',
    'trash',
    'user',
    'users',
    'wrench'
  ],
  custom: [
    'badger',
    'badger2',
    'cloop'
  ],
  alias: [
    'alert',
    'check-circle',
    'checked',
    'dot-circle',
    'dotted',
    'face-frown',
    'info',
    'ok',
    'sad',
    'square',
    'unchecked',
    'undo',
    'undotted',
    'warning'
  ]
};

const iconNames = [
  'alert',
  'angle-down',
  'angle-left',
  'angle-right',
  'angle-up',
  'arrow-down',
  'arrow-left',
  'arrow-right',
  'arrow-up',
  'asterisk',
  'at',
  'badger',
  'badger2',
  'ban',
  'bars',
  'caret-down',
  'caret-left',
  'caret-right',
  'caret-square-left',
  'caret-square-right',
  'caret-up',
  'cat',
  'check',
  'check-circle',
  'check-square',
  'checked',
  'circle',
  'circle-check',
  'circle-exclamation',
  'circle-question',
  'clipboard-list',
  'cloop',
  'cog',
  'cogs',
  'dot-circle',
  'dotted',
  'exclamation-triangle',
  'face-frown',
  'filter',
  'info',
  'info-circle',
  'key',
  'ok',
  'plus',
  'radiation',
  'rotate-left',
  'sad',
  'search',
  'sort',
  'sort-down',
  'sort-up',
  'square',
  'times',
  'times-circle',
  'toggle-off',
  'toggle-on',
  'trash',
  'unchecked',
  'undo',
  'undotted',
  'user',
  'users',
  'warning',
  'wrench'
];

// NOTE: we use common JS style here so that we can require() this
// file when making an extended icon set based on these icons
module.exports = { iconSets, iconNames }
